<template>
  <div class="geofence-instruction-preview">
    <div class="heading">Widget</div>
    <div class="card">
      <div class="row">
        <h3>{{ preview.title }}</h3>
        <div class="column end medium-8">
          <div v-html="preview.tnc.text"></div>
          <!-- <div class="steps">
            <b>Step 1:</b> Exit the double doors outside the Baggage Claim Area.
          </div>
          <div class="steps">
            <b>Step 2:</b> Head upstairs to the Upper Departures/Ticketing Level. 	
            You can reach the upper level either by stair, escalator or elevator. 	
            All Shared-Ride pickups must occur curbside on the Upper Departure/Ticketing	
            Level at the “Ride Service” sign lettered A-F.	
          </div>
          <div class="steps">
            <b>Step 3:</b> At this time, if you have not received a phone call from us, 	
            please call our Dispatch Department at 1-800-733-8267 and select option 3 or 	
            our Vehicle Status Line at 1-310-464-0372.	
          </div>
          <div class="steps">
            <b>Step 4:</b> Provide the Dispatch Agent with your reservation number. 	
            The agent will check you in and provide the latest information regarding 	
            your reservation.	
          </div> -->
        </div>
        <div class="column end medium-4">
          <img :src="preview.tnc.img" class="thumbnail" />
          <!-- <img src="https://stage-opoli-uploads.s3.us-west-2.amazonaws.com/02843719-a5ad-48e6-8e29-f68f2dc09cc0.jpg" class="thumbnail" /> -->
          <span class="large-view">Click image for larger view</span>
        </div>
      </div>
    </div>

    <div class="heading">Consumer App</div>
    <div class="ca-app">
      <div class="heading">
        <div class="left"><i class="fas fa-arrow-left"></i></div>
        <div class="right">Pickup at LAX</div>
      </div>
      <div class="body">
        <div v-html="preview.tnc.text"></div>
        <!-- <div class="steps">
          <b>Step 1:</b> Exit the double doors outside the Baggage Claim Area.
        </div>
        <div class="steps">
          <b>Step 2:</b> Head upstairs to the Upper Departures/Ticketing Level. 	
          You can reach the upper level either by stair, escalator or elevator. 	
          All Shared-Ride pickups must occur curbside on the Upper Departure/Ticketing	
          Level at the “Ride Service” sign lettered A-F.	
        </div>
        <div class="steps">
          <b>Step 3:</b> At this time, if you have not received a phone call from us, 	
          please call our Dispatch Department at 1-800-733-8267 and select option 3 or 	
          our Vehicle Status Line at 1-310-464-0372.	
        </div>
        <div class="steps">
          <b>Step 4:</b> Provide the Dispatch Agent with your reservation number. 	
          The agent will check you in and provide the latest information regarding 	
          your reservation.	
        </div> -->

        <img :src="preview.tnc.img" class="thumbnail" />
        <!-- <img src="https://stage-opoli-uploads.s3.us-west-2.amazonaws.com/02843719-a5ad-48e6-8e29-f68f2dc09cc0.jpg" class="image" /> -->
        <a class="next-button">OK, I understand.</a>
      </div>
    </div>

  </div>
</template>

<script>
import airportGeofenceAPI from '@/modules/api/geofences/airport'

export default {
  name: 'geofence-instruction-preview',
  data () {
    return {
    }
  },
  computed: {
    preview () { return this.$store.state.geofences.preview },
  },
  methods: {
    // updateField (field) {
    // }
  },
  watch: {
    preview: function (value) {
      console.log('watch', value)
    }
  },
  mounted () {
    console.log('!', this.preview)
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Questrial');
@import url('https://fonts.googleapis.com/css?family=Work+Sans');
@import url('https://fonts.googleapis.com/css?family=Montserrat%3A400%2C500%2C600%2C700%2C800%2C900&#038;display=swap&#038;ver=4.6.1');

#side-menu{ display: none; }
.row{ max-width: 62.5rem; }

.geofence-instruction-preview{
  padding: 20px;

  .heading{
    font-size: 21px;
    color: #0D79F2;
    margin-bottom: 5px;
    font-weight: 600;
  }
}

.card{
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,.15);
  border: 1px solid rgba(0,0,0,.2);
  padding: 20px;
  color: #2c3e50;
  margin-bottom: 30px;
  display: inline-block;
  font-family: 'Montserrat', sans-serif;

  .column.medium-8{ padding-right: 10px; }
  h3{
    font-size: 1.5em;
    margin: 0 0 5px;
    font-weight: 500;
  }
  .steps{
    font-size: 15px;
    margin-bottom: 5px;

    .step{ margin-bottom:3px; }
    strong{ margin-right: 3px; }
  }
  .thumbnail{ cursor: pointer; }
  .large-view{
    font-size: 13px;
    display: block;
    text-align: center;
  }
}

.ca-app{
  width: 100%;
  max-width: 450px;
  background: #f9f9f9;
  font-family: 'Work Sans', san-serif;
  box-shadow: 0 2px 4px rgba(0,0,0,.15);

  .heading{
    height: 56px;
    line-height: 56px;
    overflow: hidden;
    background: #009688;
    color: #fff;
    font-weight: 500;

    .left{
      text-align: center;
      display: inline-block;
      width: 75px;
    }
    .right{
      display: inline-block;
      font-size: 20px;
      vertical-align: top;
      color: #ffffff;
      width: auto;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .body{
    padding: 15px;

    .steps{
      line-height: 1.3;
      margin-bottom: 10px;
      color: #555;
      b{ color: #1f1f21; }
    }
    .image{
      margin-top: 10px;
      width: 100%;
    }
    .next-button{
      color: #fff;
      display: block;
      text-align: center;
      font-weight: 700;
      text-decoration: none;
      padding: 10px;
      margin: 15px;
      border-radius: 3px;
      background: #009688;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/InstructionPreview.vue